import { c as _c } from "react/compiler-runtime";
export default function FacebookIcon() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_377_2161)"><path d="M90 45C90 20.1474 69.8526 0 45 0C20.1474 0 0 20.1474 0 45C0 66.1032 14.5296 83.8116 34.1298 88.6752V58.752H24.8508V45H34.1298V39.0744C34.1298 23.7582 41.0616 16.659 56.0988 16.659C58.95 16.659 63.8694 17.2188 65.8818 17.7768V30.2418C64.8198 30.1302 62.9748 30.0744 60.6834 30.0744C53.3052 30.0744 50.454 32.8698 50.454 40.1364V45H65.1528L62.6274 58.752H50.454V89.6706C72.7362 86.9796 90.0018 68.0076 90.0018 45H90Z" fill="#0866FF" /><path d="M62.6257 58.7519L65.1511 44.9999H50.4523V40.1363C50.4523 32.8697 53.3035 30.0743 60.6817 30.0743C62.9731 30.0743 64.8181 30.1301 65.8801 30.2417V17.7767C63.8677 17.2169 58.9483 16.6589 56.0971 16.6589C41.0599 16.6589 34.1281 23.7581 34.1281 39.0743V44.9999H24.8491V58.7519H34.1281V88.6751C37.6093 89.5391 41.2507 89.9999 44.9983 89.9999C46.8433 89.9999 48.6631 89.8865 50.4505 89.6705V58.7519H62.6239H62.6257Z" fill="white" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="tw-h-full tw-w-full tw-align-top" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">{t0}<defs><clipPath id="clip0_377_2161"><rect width="90" height="90" fill="white" /></clipPath></defs></svg>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}